<template>
    <v-container fluid class="pa-0">
        <!-- loading status -->
        <v-row class="ma-0 pa-0">
            <v-progress-linear
                v-if="$apollo.queries.greenhouses.loading"
                color="primary"
                indeterminate
                rounded
                class="ma-0 pa-0"
            ></v-progress-linear>
        </v-row>
        <v-row class="align-start mb-0 px-3 mr-0" align="center">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Planning Tool', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>

            <v-spacer></v-spacer>
            <v-col cols="12" sm="3" md="2" class="mt-3 pb-0">
                <v-select
                    v-model="selectedGreenhouse"
                    :items="greenhouses.edges"
                    item-text="node.name"
                    item-value="node"
                    label="Greenhouse"
                    dense
                    hide-details
                    :loading="isLoadingGreenhouses"
                >
                </v-select>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="mt-3 pb-0">
                <v-select
                    v-model="selectedYear"
                    :items="taskYears"
                    label="Year"
                    dense
                    hide-details
                >
                </v-select>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="mt-3 pb-0">
                <v-select
                    ref="v_select_folder"
                    dense
                    hide-details
                    v-model="selectedPlanFolder"
                    label="Plan Folder"
                    :items="tenantPlannedFolder"
                    item-value="node.id"
                    item-text="node.name"
                    return-object
                >
                    <template v-slot:append-item>
                        <v-list-item v-if="hasPermission('change_plannedtask')">
                            <v-btn
                                color="primary"
                                small
                                block
                                outlined
                                @click="newFolderDialog"
                            >
                                CREATE FOLDER
                            </v-btn>
                        </v-list-item>
                    </template>
                </v-select>
            </v-col>
            <v-btn
                icon
                class="mt-7 pb-0"
                small
                v-if="hasPermission('change_plannedtask')"
                :disabled="selectedPlanFolder.node.id == null ? true : false"
                @click="changeFolderNameFunction"
            >
                <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
                icon
                class="mt-7 pb-0"
                color="red"
                small
                v-if="hasPermission('delete_plannedtask')"
                :disabled="selectedPlanFolder.node.id == null ? true : false"
                @click="deleteFolderDialogFunction"
            >
                <v-icon>delete</v-icon>
            </v-btn>
        </v-row>

        <!-- Create New Folder Dialog -->
        <CreateNewFolderDialog
            :newFolderDialogVisibility="openNewFolderDialog"
            v-on:closeNewFolderDialog="openNewFolderDialog = false"
            v-on:newFolderCreated="onNewFolderCreated"
        ></CreateNewFolderDialog>

        <!-- Change Folder Name dialog -->
        <ChangeFolderNameDialog
            :changeNameDialog="openChangeFolderNameDialog"
            :targetFolderID="selectedPlanFolderID"
            :parentSelectedValue.sync="selectedPlanFolderName"
            v-on:closeChangeFolderNameDialog="
                openChangeFolderNameDialog = false
            "
            v-on:planFolderNameChanged="planFolderNameChanged"
        ></ChangeFolderNameDialog>

        <!-- Copy/Move a Task to other Folder Dialog -->
        <MovePlannedTaskDialog
            :openMovePlanDialog="openMoveTaskFolder"
            v-on:closeMoveTaskDialog="openMoveTaskFolder = false"
            :dropdownValue="tenantPlannedFolder"
        ></MovePlannedTaskDialog>

        <!-- Planned task space -->
        <PlannedTaskSpaceChartDialog
            ref="plannedTaskSpaceChartDialogRef"
            :dialog.sync="plannedTaskSpaceChartDialog"
        ></PlannedTaskSpaceChartDialog>

        <!-- Add planned task dialog -->
        <PlannedTaskEditDialog
            ref="plannedTaskEditDialogRef"
            :dialog.sync="plannedTaskEditDialog"
            :PlanFolderID="selectedPlanFolderID"
            :dropdownValue="tenantPlannedFolder"
            :DialogTitle="PlannedTaskEditaDialogTitle"
            :currentlySelectedFolder="selectedPlanFolder"
            :createOrCopyPlanToFolderBool="createOrCopyPlanToFolder"
            v-on:item-created="onPlannedTaskCreated"
            v-on:setCreateOrCopyPlanFalse="createOrCopyPlanToFolder = false"
        ></PlannedTaskEditDialog>

        <!-- Create growth task dialog -->
        <CreateGrowthTaskFromPlannedTaskDialog
            ref="createGrowthTaskFromPlannedTaskDialogRef"
            :dialog.sync="createGrowthTaskFromPlannedTaskDialog"
            v-on:item-created="onGrowthTaskCreated"
        >
        </CreateGrowthTaskFromPlannedTaskDialog>

        <!-- Delete Plan Dialog -->
        <DeleteDialog
            :dialog.sync="deletePlannedTaskDialog"
            :item="deletingPlannedTask"
            v-on:confirmed="deletePlannedTaskConfirmed"
        >
            <template v-slot:title>Delete Plan</template>
            <template v-slot:content
                >Are you sure you want to delete this plan? All phases in this
                plan will be deleted!!
                <br />
                <strong v-if="deletingPlannedTask.growthStartDate"
                    >{{ deletingPlannedTask.plant.name }} ({{
                        deletingPlannedTask.growthStartDate | moment("YYYY")
                    }}-w{{ deletingPlannedTask.growthStartDate | moment("w") }})
                    {{ deletingPlannedTask.quantity }}
                </strong>
            </template>
        </DeleteDialog>

        <!-- Delete Plan Folder Dialog -->
        <!-- <confirmDeleteForderDeleteDialog
            :folderName="selectedPlanFolderName"
            :selectedFolderID="selectedPlanFolderID"
            :openDeleteDialog="deleteFolderDialog"
            v-on:closeDeleteFolderDialog="deleteFolderDialog = false"
            v-on:stopLoadingDelete="isLoadingDeleteFolder = false"
            v-on:refetchAfterDelete="afterFolderDelete"
        >
        </confirmDeleteForderDeleteDialog> -->

        <!-- Delete PlanFolder Dialog -->
        <DeleteDialog
            :dialog.sync="deleteFolderDialog"
            :item="selectedPlanFolder"
            v-on:confirmed="deletePlanFolderConfirmed"
        >
            <template v-slot:title>Delete Plan Folder</template>
            <template v-slot:content
                >Are you sure you want to delete this plan folder? All plans in
                this folder will be deleted!!
                <br />
                <strong>{{ selectedPlanFolder.node.name }} </strong>
            </template>
        </DeleteDialog>

        <!-- plant Dialog -->
        <v-dialog v-model="plantDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closePlantDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{
                        selectedPlantNode ? selectedPlantNode.name : "Plant"
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToPlantDetail(selectedPlantNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <PlantDetailComponent
                        v-if="selectedPlantNodeId"
                        :plantNodeId="selectedPlantNodeId"
                        v-on:plant-items-updated="getPlannedTaskPhases"
                        v-on:item-deleted="getPlannedTaskPhases"
                    ></PlantDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Greenhouse planned space -->
        <v-row class="ma-0">
            <v-col cols="12" class="pb-0">
                <GreenhousePlannedSpaceChart
                    ref="greenhousePlannedSpaceRef"
                    v-on:week-selected="onGreenhouseChartWeekSelected"
                >
                    <template v-slot:header>
                        <v-row class="px-8 pt-3">
                            <v-spacer></v-spacer>
                            <span class="headline">Greenhouse Space</span>
                            <span class="caption ml-2 pt-2"
                                >({{
                                    selectedGreenhouse.totalSpaceM2
                                }}
                                m2)</span
                            >
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        color="grey"
                                        v-on="on"
                                        @click="refreshWholePageData()"
                                    >
                                        <v-icon>refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>Refresh</span>
                            </v-tooltip>
                        </v-row>
                    </template>
                </GreenhousePlannedSpaceChart>
            </v-col>
        </v-row>

        <!-- finance chart -->
        <v-row class="ma-0">
            <v-col cols="12" class="pb-0">
                <GreenhousePlannedFinanceChart
                    ref="greenhousePlannedFinanceRef"
                >
                </GreenhousePlannedFinanceChart>
            </v-col>
        </v-row>

        <!-- toggle departments or plan list -->
        <v-row class="pa-2 mx-1" align="center">
            <v-btn-toggle
                v-model="toggleViewType"
                class="ml-6 mr-6"
                dense
                mandatory
                rounded
            >
                <v-btn small active-class="primary--text">
                    <v-icon
                        :color="toggleViewType == 0 ? 'primary' : 'grey'"
                        small
                        >view_quilt</v-icon
                    >
                    <span class="hidden-sm-and-down">Deparments</span>
                </v-btn>
                <v-btn small active-class="primary--text">
                    <v-icon
                        :color="toggleViewType == 1 ? 'primary' : 'grey'"
                        small
                        >list</v-icon
                    >Plan List</v-btn
                >
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-btn
                v-if="hasPermission('add_plannedtask')"
                color="primary"
                dark
                outlined
                rounded
                small
                class="mr-2"
                @click="createNewPlanButton"
                >New Plan</v-btn
            >
            <vue-excel-xlsx
                :fetch="userRequestExcel"
                :columns="columns"
                :file-name="'PlanningToolExport'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
            >
                <v-btn
                    small
                    outlined
                    color="primary"
                    rounded
                    class="mx-2"
                    dense
                    :disabled="
                        tenantPlannedTaskPhases &&
                        tenantPlannedTaskPhases.edges &&
                        tenantPlannedTaskPhases.edges.length > 0
                            ? false
                            : true
                    "
                    :loading="isExportingExcel"
                >
                    Download
                </v-btn>
            </vue-excel-xlsx>
        </v-row>

        <!-- Departments -->
        <v-row v-if="toggleViewType == 0" class="ma-0">
            <v-col cols="12" class="pa-0">
                <div v-if="isLoadingGreenhouseDepartmentSet" class="mt-5 mx-3">
                    <v-progress-linear
                        indeterminate
                        rounded
                    ></v-progress-linear>
                </div>
                <div v-else>
                    <DepartmentPlannedSpaceChartList
                        :greenhouseDepartmentSet="
                            selectedGreenhouseDepartmentSet
                        "
                        :selectedYear="selectedYear"
                        :selectedPlanFolderID="selectedPlanFolderID"
                        :selectedPlanFolderName="selectedPlanFolderName"
                        v-on:openDepartmentSectionListDialog="
                            openDepartmentSectionListDialog
                        "
                    >
                    </DepartmentPlannedSpaceChartList>
                </div>
            </v-col>
        </v-row>

        <!-- Selected Department Section List Dialog -->
        <v-dialog v-model="departmentSectionListDialog" persistent scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <span class="title"
                        >{{ selectedGreenhouseDepartment.name }} -
                        {{ selectedYear }}</span
                    >
                    <span class="caption ml-2 pt-2"
                        >({{
                            selectedGreenhouseDepartment.totalSpaceM2
                        }}
                        m2)</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        :loading="isLoadingSelectedGreenhouseDepartment"
                        @click="
                            getSelectedGreenhouseDepartment(
                                selectedGreenhouseDepartment.id,
                                selectedYear,
                                selectedFolderID,
                                planFolderNullFilter
                            )
                        "
                        ><v-icon color="white">refresh</v-icon></v-btn
                    >
                    <v-btn icon @click="closeDepartmentSectionListDialog()"
                        ><v-icon color="white">close</v-icon></v-btn
                    >
                </v-toolbar>
                <v-card-text>
                    <div
                        v-if="isLoadingSelectedGreenhouseDepartment"
                        class="mt-10 text-center"
                    >
                        Loading...
                    </div>

                    <SectionPlannedSpaceChartList
                        :greenhouseDepartmentSectionSet="
                            selectedGreenhouseDepartment.greenhouseDepartmentSectionSet
                        "
                        :selectedYear="selectedYear"
                        :selectedPlanFolderID="selectedPlanFolderID"
                        :selectedPlanFolderName="selectedPlanFolderName"
                        v-on:onPlannedTaskCreated="onPlannedTaskCreated()"
                        v-on:onPlannedTaskDeleted="onPlannedTaskDeleted()"
                    >
                    </SectionPlannedSpaceChartList
                ></v-card-text>
            </v-card>
        </v-dialog>

        <!-- Planned tasks -->
        <v-row v-if="toggleViewType == 1" class="px-5">
            <!-- my calendar -->
            <v-col sm="5" md="3">
                <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    :return-value.sync="dates"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    :close-on-click="false"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            ref="dateTextField"
                            v-model="formatedDateInputField"
                            label="Start Date Range"
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            dense
                            :disabled="isLoadingPlannedTaskPhases"
                            @click:clear="clearAndRefresh()"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dates"
                        no-title
                        scrollable
                        show-week
                        range
                        :first-day-of-week="1"
                        locale-first-day-of-year="4"
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(dates)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <!-- plan list header filters -->
            <v-col cols="12" sm="4" md="2" align-self="start">
                <v-autocomplete
                    v-model="selectedPlanListDepartmentId"
                    :items="planFilterDepartmentList"
                    item-value="node.id"
                    item-text="node.name"
                    :disabled="isLoadingPlannedTaskPhases"
                    label="Department"
                    dense
                    clearable
                    hide-details
                >
                </v-autocomplete
            ></v-col>
            <v-col cols="6" sm="3" md="1" align-self="start">
                <v-autocomplete
                    v-model="selectedPlanListPhaseNo"
                    :items="planFilterPhaseList"
                    item-value="phaseNo"
                    item-text="phase"
                    :disabled="isLoadingPlannedTaskPhases"
                    label="Phase"
                    dense
                    clearable
                    hide-details
                >
                </v-autocomplete
            ></v-col>
            <v-col cols="6" sm="4" md="2" align-self="start">
                <v-autocomplete
                    v-model="selectedPlanListPotSizeId"
                    :items="planFilterPotSizeList"
                    item-value="node.id"
                    item-text="node.potSizeCm"
                    :disabled="isLoadingPlannedTaskPhases"
                    label="Pot Size (cm)"
                    dense
                    clearable
                    hide-details
                >
                </v-autocomplete
            ></v-col>
            <v-col cols="12" sm="5" md="2" align-self="start">
                <v-text-field
                    dense
                    v-model="search"
                    append-outer-icon="refresh"
                    :disabled="isLoadingPlannedTaskPhases"
                    @click:append-outer="getPlannedTaskPhases()"
                    label="Search"
                    clearable
                    hide-details
                    @keydown.enter="getPlannedTaskPhases()"
                    @click:clear="onClearSearch()"
                ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="3"
                md="2"
                align-self="start"
                class="d-flex justify-center"
            >
                <v-chip
                    v-if="selectedWeek"
                    class="mt-1 mr-2"
                    color="primary"
                    text-color="white"
                    close
                    small
                    @click:close="onClearSelectedWeek()"
                >
                    Week {{ selectedWeek }}
                </v-chip>
                <v-switch
                    v-model="hideDoneTasks"
                    @change="onChangeHideDoneTasks()"
                    label="Hide Done"
                    class="mr-0 mt-0"
                    hide-details
                    no-gutters
                ></v-switch>
            </v-col>
        </v-row>

        <!-- Plan task phase list table -->

        <v-row v-if="toggleViewType == 1" class="ma-0 pa-0">
            <!-- Task table -->
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card
                            :elevation="hover ? 6 : 3"
                            :loading="isLoadingPlannedTaskPhases"
                        >
                            <v-container fluid>
                                <v-data-table
                                    dense
                                    :headers="headers"
                                    :items="tenantPlannedTaskPhases.edges"
                                    :options.sync="dataTableOptions"
                                    :items-per-page="defaultItemsPerPage"
                                    :server-items-length="
                                        tenantPlannedTaskPhases.totalCount
                                    "
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination': isLoadingPlannedTaskPhases
                                    }"
                                    loading-text="Loading... Please wait"
                                >
                                    <template
                                        v-slot:item.node.startDate="{ item }"
                                    >
                                        <span class="text-no-wrap">{{
                                            item.node.startDate
                                                | moment("YYYY-MM-DD ([W]WW)")
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.plant.name="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap">
                                            {{
                                                item.node.plannedTask.plant.name
                                            }}
                                            <v-btn
                                                icon
                                                small
                                                color="primary"
                                                @click="
                                                    openPlantDialog(
                                                        item.node.plannedTask
                                                            .plant
                                                    )
                                                "
                                            >
                                                <v-icon small
                                                    >remove_red_eye</v-icon
                                                >
                                            </v-btn>
                                        </span>
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.potSize.potSizeCm="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap"
                                            >{{
                                                item.node.plannedTask.potSize
                                                    .potSizeCm
                                            }}
                                            cm</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.quantity="{
                                            item
                                        }"
                                    >
                                        <v-edit-dialog
                                            :return-value.sync="
                                                item.node.plannedTask.quantity
                                            "
                                            large
                                            @save="
                                                onSavePlanQuantity(
                                                    item.node.plannedTask
                                                )
                                            "
                                            v-if="
                                                hasPermission(
                                                    'change_plannedtask'
                                                )
                                            "
                                        >
                                            <span
                                                v-if="item.node.phaseNo == 1"
                                                class="primary--text"
                                                >+{{
                                                    item.node.plannedTask
                                                        .quantity
                                                }}
                                            </span>
                                            <span
                                                v-else-if="
                                                    item.node.isSalesPhase
                                                "
                                                class="primary--text"
                                                >{{
                                                    (
                                                        item.node.plannedTask
                                                            .quantity *
                                                        (1 -
                                                            item.node
                                                                .plannedTask
                                                                .failureRate)
                                                    ).toFixed(0)
                                                }}
                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }"
                                                        ><v-icon
                                                            small
                                                            color="grey"
                                                            v-on="on"
                                                            >error_outline</v-icon
                                                        >
                                                    </template>
                                                    <span
                                                        >{{
                                                            item.node
                                                                .plannedTask
                                                                .failureRate *
                                                                100 || 0
                                                        }}% failure</span
                                                    >
                                                </v-tooltip>
                                            </span>
                                            <span v-else class="primary--text"
                                                >{{
                                                    item.node.plannedTask
                                                        .quantity
                                                }}
                                            </span>
                                            <template v-slot:input>
                                                <v-text-field
                                                    v-model="
                                                        item.node.plannedTask
                                                            .quantity
                                                    "
                                                    label="Edit"
                                                    type="number"
                                                    single-line
                                                ></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                        <span v-else-if="item.node.phaseNo == 1"
                                            >+{{
                                                item.node.plannedTask.quantity
                                            }}
                                        </span>
                                        <span v-else
                                            >{{
                                                item.node.plannedTask.quantity
                                            }}
                                        </span>
                                    </template>
                                    <template
                                        v-slot:item.node.phaseNo="{ item }"
                                    >
                                        <v-chip
                                            class="my-1"
                                            small
                                            color="warning"
                                            v-if="item.node.isSalesPhase"
                                            >Sales</v-chip
                                        >
                                        <v-chip
                                            class="my-1"
                                            small
                                            dark
                                            color="success"
                                            v-else-if="item.node.phaseNo == 1"
                                            >P{{ item.node.phaseNo }}</v-chip
                                        >
                                        <v-chip
                                            class="my-1"
                                            small
                                            outlined
                                            color="success"
                                            v-else
                                            >P{{ item.node.phaseNo }}</v-chip
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.growthCost="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap">
                                            -€{{
                                                item.node.plannedTask.growthCost
                                                    ? item.node.plannedTask.growthCost
                                                          .toFixed(0)
                                                          .toLocaleString()
                                                    : 0
                                            }}</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.totalOperatingCostValue="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap">
                                            -€{{
                                                item.node.plannedTask.totalOperatingCostValue
                                                    .toFixed(0)
                                                    .toLocaleString()
                                            }}
                                        </span>
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.productFixedCostValue="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap">
                                            -€{{
                                                item.node.plannedTask.productFixedCostValue
                                                    .toFixed(0)
                                                    .toLocaleString()
                                            }}
                                        </span>
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.expectedRevenue="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap">
                                            €{{
                                                item.node.plannedTask
                                                    .expectedRevenue
                                                    ? item.node.plannedTask.expectedRevenue
                                                          .toFixed(0)
                                                          .toLocaleString()
                                                    : 0
                                            }}
                                        </span>
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.expectedProfit="{
                                            item
                                        }"
                                    >
                                        <span class="text-no-wrap">
                                            €{{
                                                item.node.plannedTask
                                                    .expectedProfit
                                                    ? item.node.plannedTask.expectedProfit
                                                          .toFixed(0)
                                                          .toLocaleString()
                                                    : 0
                                            }}
                                        </span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <span>
                                            <v-icon
                                                small
                                                class="mr-2"
                                                :disabled="
                                                    isLoadingPlannedTaskPhases
                                                "
                                                @click="
                                                    viewPlannedTask(
                                                        item.node.plannedTask
                                                    )
                                                "
                                                >remove_red_eye</v-icon
                                            >
                                            <v-icon
                                                v-if="
                                                    hasPermission(
                                                        'change_plannedtask'
                                                    )
                                                "
                                                small
                                                class="mr-2"
                                                :disabled="
                                                    isLoadingPlannedTaskPhases
                                                "
                                                @click="
                                                    editPlannedTask(
                                                        item.node.plannedTask,
                                                        $event
                                                    )
                                                "
                                                >edit</v-icon
                                            >
                                            <v-icon
                                                ref="copyPlanIcon"
                                                id="copyPlanIcon"
                                                class="mr-2"
                                                @click="
                                                    editPlannedTask(
                                                        item.node.plannedTask,
                                                        $event
                                                    )
                                                "
                                                small
                                            >
                                                content_copy
                                            </v-icon>
                                            <v-icon
                                                v-if="
                                                    hasPermission(
                                                        'delete_plannedtask'
                                                    )
                                                "
                                                small
                                                :disabled="
                                                    isLoadingPlannedTaskPhases
                                                "
                                                @click="
                                                    onDeletingPlannedTask(
                                                        item.node.plannedTask
                                                    )
                                                "
                                                >delete</v-icon
                                            >
                                        </span>
                                    </template>
                                    <template
                                        v-slot:item.node.m2Days="{
                                            item
                                        }"
                                    >
                                        €{{ item.node.m2Days.toLocaleString() }}
                                    </template>
                                    <template
                                        v-slot:item.node.plannedTask.isDone="{
                                            item
                                        }"
                                    >
                                        <v-icon
                                            v-if="item.node.plannedTask.isDone"
                                            color="success"
                                            >check_circle</v-icon
                                        >
                                        <v-btn
                                            v-else-if="
                                                hasPermission('add_growthtask')
                                            "
                                            x-small
                                            outlined
                                            rounded
                                            :disabled="
                                                isLoadingPlannedTaskPhases
                                            "
                                            @click="
                                                openCreateGrowthTaskFromPlannedTask(
                                                    item.node.plannedTask.id
                                                )
                                            "
                                        >
                                            Create
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import GreenhousePlannedSpaceChart from "@/components/planner/GreenhousePlannedSpaceChart.vue";
import GreenhousePlannedFinanceChart from "@/components/planner/GreenhousePlannedFinanceChart.vue";
import DepartmentPlannedSpaceChartList from "@/components/planner/DepartmentPlannedSpaceChartList.vue";
import SectionPlannedSpaceChartList from "@/components/planner/SectionPlannedSpaceChartList.vue";
import PlannedTaskSpaceChartDialog from "@/components/planner/PlannedTaskSpaceChartDialog.vue";
import PlannedTaskEditDialog from "@/components/planner/PlannedTaskEditDialog.vue";
import CreateGrowthTaskFromPlannedTaskDialog from "@/components/planner/CreateGrowthTaskFromPlannedTaskDialog.vue";
import DeleteDialog from "@/components/base/DeleteDialog.vue";
import PlantDetailComponent from "@/components/plants/PlantDetailComponent.vue";
import MovePlannedTaskDialog from "@/components/planner/MovePlannedTaskDialog.vue";
import CreateNewFolderDialog from "@/components/planner/CreateNewFolderDialog.vue";
import ChangeFolderNameDialog from "@/components/planner/ChangeFolderNameDialog.vue";
import moment from "moment";

export default {
    name: "planning-tool-page",
    components: {
        GreenhousePlannedSpaceChart,
        GreenhousePlannedFinanceChart,
        DepartmentPlannedSpaceChartList,
        SectionPlannedSpaceChartList,
        PlannedTaskSpaceChartDialog,
        PlannedTaskEditDialog,
        CreateGrowthTaskFromPlannedTaskDialog,
        DeleteDialog,
        PlantDetailComponent,
        MovePlannedTaskDialog,
        CreateNewFolderDialog,
        ChangeFolderNameDialog
    },

    apollo: {
        planFolders: {
            query: gql`
                query tenantPlannedFolder {
                    tenantPlannedFolder {
                        edges {
                            node {
                                id
                                name
                            }
                        }
                    }
                }
            `,
            variables() {},
            fetchPolicy: "cache-and-network",
            update(data) {
                this.tenantPlannedFolder = JSON.parse(
                    JSON.stringify(data.tenantPlannedFolder.edges)
                );
                this.tenantPlannedFolder.unshift({
                    node: { id: null, name: "Default" }
                });
                return data.tenantPlannedFolder.edges;
            }
        },
        greenhouses: {
            query: gql`
                query greenhouses {
                    greenhouses {
                        edges {
                            node {
                                id
                                name
                                width
                                height
                                totalSpaceM2
                            }
                        }
                    }
                }
            `,
            variables() {},
            // Additional options here
            fetchPolicy: "cache-and-network",
            update(data) {
                const greenhouse = data.greenhouses.edges.find(
                    element => element.node.id == this.selectedGreenhouse.id
                );

                if (data.greenhouses.edges.length > 0 || !greenhouse) {
                    this.selectedGreenhouse = data.greenhouses.edges[0].node;
                }

                return data.greenhouses;
            }
            // pollInterval: 60000 // ms
            // pollInterval: 300 // ms
        }
    },

    data: function() {
        return {
            default: {
                node: {
                    value: null,
                    text: "Default"
                }
            },
            dates: [],
            /*----> Loading data <----*/
            isLoadingGreenhouses: false,
            isLoadingGreenhouseDepartmentSpaces: false,
            isLoadingGreenhouseDepartmentSet: false,
            isLoadingSelectedGreenhouseDepartment: false,
            isLoadingPlannedTaskPhases: false,
            isLoadingDeleteFolder: false,

            /*----> Planned Task data <----*/
            tenantPlannedTaskPhases: {},
            tenantClosedPlannedTasks: {},
            deletingPlannedTask: { plant: {} },
            plannedTaskSpaceChartDialog: false,
            plannedTaskEditDialog: false,
            PlannedTaskEditaDialogTitle: "",
            createGrowthTaskFromPlannedTaskDialog: false,
            deletePlannedTaskDialog: false,
            hideDoneTasks: false,

            /* ------> Plant data <-----*/
            plantDialog: false,
            selectedPlantNodeId: null,
            selectedPlantNode: null,
            departmentSectionListDialog: false,

            /*<----- Plan Folder data ----->*/
            tenantPlannedFolder: [],
            newFolderName: "",
            defaultPlanFolder: { node: { id: null, name: "Default" } },
            selectedPlanFolder: { node: { id: null, name: "Default" } },
            selectedPlanFolderID: null,
            selectedPlanFolderName: "Default",
            planFolderNullFilter: true,
            openMoveTaskFolder: false,
            openNewFolderDialog: false,
            openChangeFolderNameDialog: false,
            deleteFolderDialog: false,
            createOrCopyPlanToFolder: false,

            /* <---- Greenhouse data ----> */
            greenhouses: {},
            selectedGreenhouse: {},
            selectedGreenhouseDepartment: {},
            selectedGreenhouseDepartmentSet: {},

            /* <---- Excel variable and columns ----> */
            isExportingExcel: false,
            columns: [
                {
                    label: "Plan ID",
                    field: "node.plannedTask.rawId"
                },
                {
                    label: "Start Date",
                    field: "node.startDate"
                },
                {
                    label: "End Date",
                    field: "node.endDate"
                },
                {
                    label: "Department",
                    field:
                        "node.greenhouseDepartmentSection.greenhouseDepartment.name"
                },
                {
                    label: "Sector",
                    field: "node.greenhouseDepartmentSection.name"
                },
                {
                    label: "Plant Species",
                    field: "node.plannedTask.plant.plantSpecies.name"
                },
                {
                    label: "Plant",
                    field: "node.plannedTask.plant.name"
                },
                {
                    label: "Pot",
                    field: "node.plannedTask.potSize.potSizeCm"
                },
                {
                    label: "Color",
                    field: "node.plannedTask.color.color"
                },
                {
                    label: "Environment",
                    field: "node.plannedTask.environment.environment"
                },
                {
                    label: "Tag",
                    field: {
                        callback: value => {
                            return value.node.plannedTask.tag
                                ? value.node.plannedTask.tag.tag
                                : "";
                        }
                    }
                },
                {
                    label: "Supplier",
                    field: {
                        callback: value => {
                            return value.node.plannedTask.supplier
                                ? value.node.plannedTask.supplier.name
                                : "";
                        }
                    }
                },
                {
                    label: "PhaseNo",
                    field: {
                        callback: value => {
                            if (value.node.isSalesPhase) return "Sales";
                            else return "P" + value.node.phaseNo;
                        }
                    }
                },
                {
                    label: "Quantity",
                    field: "node.plannedTask.quantity"
                },
                {
                    label: "Space(m2)",
                    field: "node.spaceM2"
                },
                {
                    label: "Growth Cost",
                    field: {
                        callback: value => {
                            return parseFloat(
                                value.node.plannedTask.growthCost
                            ).toFixed(2);
                        }
                    }
                },
                {
                    label: "Business Cost",
                    field: {
                        callback: value => {
                            return parseFloat(
                                value.node.plannedTask.totalOperatingCostValue
                            ).toFixed(2);
                        }
                    }
                },
                {
                    label: "Product Cost",
                    field: {
                        callback: value => {
                            return parseFloat(
                                value.node.plannedTask.productFixedCostValue
                            ).toFixed(2);
                        }
                    }
                },
                {
                    label: "Revenue",
                    field: {
                        callback: value => {
                            return parseFloat(
                                value.node.plannedTask.expectedRevenue
                            ).toFixed(2);
                        }
                    }
                },
                {
                    label: "Profit",
                    field: {
                        callback: value => {
                            return parseFloat(
                                value.node.plannedTask.expectedProfit
                            ).toFixed(2);
                        }
                    }
                }
            ],
            sorters: [
                "node.startDate",
                "node.greenhouseDepartmentSection.greenhouseDepartment.name",
                "node.greenhouseDepartmentSection.name"
            ],
            defaultSorters: [
                "node.startDate",
                "node.greenhouseDepartmentSection.greenhouseDepartment.name",
                "node.greenhouseDepartmentSection.name",
                "node.plannedTask.plant.plantSpecies.name",
                "node.plannedTask.plant.name",
                "node.plannedTask.potSize.potSizeCm",
                "node.plannedTask.color.color",
                "node.plannedTask.environment.environment",
                "node.plannedTask.tag.tag"
            ],

            /* <---- Plan list data ---->*/
            selectedPlanListDepartmentId: null,
            selectedPlanListPhaseNo: null,
            selectedPlanListPotSizeId: null,
            planFilterDepartmentList: [],
            planFilterPhaseList: [
                { phase: "P1", phaseNo: 1 },
                { phase: "P2", phaseNo: 2 },
                { phase: "P3", phaseNo: 3 },
                { phase: "P4", phaseNo: 4 },
                { phase: "P5", phaseNo: 5 },
                { phase: "P6", phaseNo: 6 },
                { phase: "P7", phaseNo: 7 },
                { phase: "P8", phaseNo: 8 },
                { phase: "P9", phaseNo: 9 },
                { phase: "P10", phaseNo: 10 },
                { phase: "Sales", phaseNo: 0 }
            ],
            planFilterPotSizeList: [],

            /* <---- Data Table options ----> */
            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,
            shouldResetDataTablePage: false,
            toggleViewType: 0,
            expectedProfit: [],
            activeTab: null,

            search: "",
            // selectedGreenhouseNodeId: null,
            selectedYear: null,
            selectedWeek: null,
            selectedIsSalePhase: null,

            /*------> Table headers <---------*/
            headers: [
                {
                    text: "Plan ID",
                    value: "node.plannedTask.rawId",
                    sortable: true
                },
                {
                    text: "Start Date",
                    value: "node.startDate",
                    sortable: true
                },
                {
                    text: "Department",
                    value:
                        "node.greenhouseDepartmentSection.greenhouseDepartment.name",
                    sortable: true
                },
                {
                    text: "Sector",
                    value: "node.greenhouseDepartmentSection.name",
                    sortable: true
                },
                {
                    text: "Plant Species",
                    value: "node.plannedTask.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "node.plannedTask.plant.name",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.plannedTask.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    align: "left",
                    value: "node.plannedTask.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.plannedTask.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.plannedTask.tag.tag",
                    sortable: true
                },
                {
                    text: "Supplier",
                    value: "node.plannedTask.supplier.name",
                    sortable: true
                },
                {
                    text: "Phase No",
                    value: "node.phaseNo",
                    sortable: true
                },
                {
                    text: "Quantity",
                    value: "node.plannedTask.quantity",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Space(m2)",
                    value: "node.spaceM2",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Growth Cost",
                    value: "node.plannedTask.growthCost",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Business Cost",
                    value: "node.plannedTask.totalOperatingCostValue",
                    align: "right",
                    sortable: false
                },
                {
                    text: "Product Cost",
                    value: "node.plannedTask.productFixedCostValue",
                    align: "right",
                    sortable: false
                },
                {
                    text: "Revenue",
                    value: "node.plannedTask.expectedRevenue",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Profit",
                    value: "node.plannedTask.expectedProfit",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: true
                },
                {
                    text: "Growth Task",
                    value: "node.plannedTask.isDone",
                    align: "center",
                    sortable: true
                }
            ]
        };
    },
    computed: {
        ganttchartHeight() {
            return this.series[0].data.length * 40 + 60;
        },
        taskYears() {
            // initialize taskYear list and selectedYear
            let _thisYear = new Date().getFullYear();

            return Array.from({ length: 5 }, (_, i) => _thisYear - 2 + i);
        },
        formatedDateInputField: {
            get() {
                return this.dates && this.dates.length > 1
                    ? this.dates.join(" to ").replace(/-/g, "/")
                    : "";
            },
            set(value) {
                this.dates = value === null ? [] : value;
            }
        }
    },
    watch: {
        dates() {
            let savedDate;
            if (this.dates[0] > this.dates[1]) {
                savedDate = this.dates[0];
                this.dates[0] = this.dates[1];
                this.dates[1] = savedDate;
            }
            if (this.dates.length == 2 || this.dates == [])
                this.refreshWholePageData();
        },
        selectedGreenhouse: {
            handler() {
                this.selectedWeek = null;
                this.selectedPlanListDepartmentId = null;
                this.selectedPlanListPhaseNo = null;

                this.refreshWholePageData();
            },
            deep: true
        },
        selectedPlanFolder: {
            handler(n) {
                if (n) {
                    this.selectedPlanFolderName = n.node.name;
                    this.selectedPlanFolderID = n.node.id;
                    localStorage.setItem(
                        "planningToolSelectedFolder",
                        JSON.stringify(n)
                    );
                    if (n.node.id != null) this.planFolderNullFilter = false;
                    else this.planFolderNullFilter = true;
                    this.refreshWholePageData();
                }
            },
            deep: true
        },
        selectedYear(n, o) {
            this.selectedWeek = null;
            this.selectedPlanListDepartmentId = null;
            this.selectedPlanListPhaseNo = null;

            localStorage.setItem("planningToolSelectedYear", n);

            // don't refresh when initialize
            if (o) {
                this.refreshWholePageData();
            }
        },
        selectedWeek(val) {
            if (val) {
                this.toggleViewType = 1;
            }
        },
        selectedPlanListDepartmentId() {
            this.shouldResetDataTablePage = true;
            this.$nextTick().then(() => {
                this.getPlannedTaskPhases();
            });
        },
        selectedPlanListPhaseNo(val) {
            this.shouldResetDataTablePage = true;
            if (val == 0) {
                this.selectedIsSalePhase = true;
            } else if (val > 0) {
                this.selectedIsSalePhase = false;
            } else {
                // this.selectedIsSalePhase = null;
            }

            this.$nextTick().then(() => {
                this.getPlannedTaskPhases();
            });
        },
        selectedPlanListPotSizeId() {
            this.shouldResetDataTablePage = true;
            this.$nextTick().then(() => {
                this.getPlannedTaskPhases();
            });
        },
        toggleViewType: {
            handler() {
                if (this.toggleViewType == 0) {
                    this.$nextTick().then(() => {
                        this.getGreenhouseDepartmentSet();
                    });
                } else {
                    this.$nextTick().then(() => {
                        this.shouldResetDataTablePage = true;
                        this.getPlannedTaskPhases();
                    });
                }
            }
        },
        dataTableOptions: {
            handler() {
                this.$nextTick().then(() => {
                    this.getPlannedTaskPhases();
                });
            },
            deep: true
        }
    },
    beforeCreated() {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        // initialize taskYear list and selectedYear
        let _thisYear = new Date().getFullYear();
        //let _selectedFolder = {node:{id:null, name:'Default'}}

        // this.taskYears = Array.from({ length: 5 }, (_, i) => _thisYear - 2 + i);

        const _planningToolSelectedYear = localStorage.getItem(
            "planningToolSelectedYear"
        );

        if (_planningToolSelectedYear) {
            this.selectedYear = parseInt(_planningToolSelectedYear);
        } else {
            this.selectedYear = _thisYear;
            localStorage.setItem("planningToolSelectedYear", _thisYear);
        }

        const _planningToolSelectedFolder = localStorage.getItem(
            "planningToolSelectedFolder"
        );

        if (_planningToolSelectedFolder) {
            this.selectedPlanFolder = JSON.parse(_planningToolSelectedFolder);
            // this.setFolderNameAndID(this.selectedPlanFolder);
        }
    },
    methods: {
        /// Plan Folder ///

        newFolderDialog() {
            this.openNewFolderDialog = true;
        },
        onNewFolderCreated(planFolder) {
            this.openNewFolderDialog = false;
            this.selectedPlanFolder = { node: planFolder };
            this.$apollo.queries.planFolders.refetch();
        },
        changeFolderNameFunction() {
            this.openChangeFolderNameDialog = true;
        },
        planFolderNameChanged(planFolder) {
            this.selectedPlanFolder = { node: planFolder };
            this.$apollo.queries.planFolders.refetch();
        },
        deleteFolderDialogFunction() {
            this.isLoadingDeleteFolder = true;
            this.deleteFolderDialog = true;
        },
        deletePlanFolderConfirmed() {
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation DeletePlanFolder(
                            $input: DeletePlanFolderInput!
                        ) {
                            deletePlanFolder(input: $input) {
                                planFolder {
                                    id
                                    name
                                }
                            }
                        }
                    `,
                    variables: {
                        input: {
                            id: this.selectedPlanFolder.node.id
                        }
                    }
                })
                .then(() => {
                    this.deleteFolderDialog = false;
                    this.selectedPlanFolder = JSON.parse(
                        JSON.stringify(this.defaultPlanFolder)
                    );
                })
                .catch(error => {
                    console.log(error);
                    //this.error = error.graphQLErrors[0].message;
                })
                .finally(() => {
                    this.$apollo.queries.planFolders.refetch();
                    this.refreshWholePageData();
                });
        },

        /// Plan ///
        openMoveTaskFolderDialog() {
            this.openMoveTaskFolder = true;
        },
        createNewPlanButton() {
            this.createOrCopyPlanToFolder = true;
            this.plannedTaskEditDialog = true;
            this.PlannedTaskEditaDialogTitle = "New Plan";
        },

        /// Download ///
        userRequestExcel() {
            this.isExportingExcel = true;

            const {
                sortBy,
                sortDesc
                //page,
                //itemsPerPage
            } = this.dataTableOptions;

            var _orderBy = null;
            const _isDone = this.hideDoneTasks ? false : null;

            switch (sortBy[0]) {
                case "node.plannedTask.rawId":
                    _orderBy = "rawId";
                    break;
                case "node.startDate":
                    _orderBy = "startDate";
                    break;
                case "node.endDate":
                    _orderBy = "endDate";
                    break;
                case "node.greenhouseDepartmentSection.greenhouseDepartment.name":
                    _orderBy = "greenhouseDepartmentName";
                    break;
                case "node.greenhouseDepartmentSection.name":
                    _orderBy = "greenhouseDepartmentSectionName";
                    break;
                case "node.plannedTask.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plannedTask.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.plannedTask.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.plannedTask.color.color":
                    _orderBy = "color";
                    break;
                case "node.plannedTask.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.plannedTask.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.plannedTask.supplier.name":
                    _orderBy = "supplierName";
                    break;
                case "node.plannedTask.expectedRevenue":
                    _orderBy = "expectedRevenue";
                    break;
                case "node.plannedTask.expectedProfit":
                    _orderBy = "expectedProfit";
                    break;
                case "node.plannedTask.growthCost":
                    _orderBy = "growthCost";
                    break;
                case "node.plannedTask.quantity":
                    _orderBy = "quantity";
                    break;
                case "node.plannedTask.youngPlantCostValue":
                    _orderBy = "youngPlantCostValue";
                    break;
                case "node.plannedTask.plantFixedCostValue":
                    _orderBy = "plantFixedCostValue";
                    break;
                case "node.plannedTask.totalOperatingCostValue":
                    _orderBy = "totalOperatingCostValue";
                    break;
                case "node.spaceM2":
                    _orderBy = "spaceM2";
                    break;
                case "node.phaseNo":
                    _orderBy = "phaseNo";
                    break;
                case "node.plannedTask.isDone":
                    _orderBy = "isDone";
                    break;
                default:
                    _orderBy = "startDate";
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            const result = this.$apollo
                .query({
                    // Query
                    query: gql`
                        query tenantPlannedTaskPhases(
                            $first: Int
                            $orderBy: String
                            $search: String
                            $greenhouse_Id: ID!
                            $greenhouseDepartment_Id: ID
                            $plannedTaskPlanFolderId: ID
                            $plannedTaskPlanFolderIdIsnull: Boolean
                            $potSize_Id: ID
                            $searchYear: Int
                            $searchWeek: Int
                            $phaseNo: Int
                            $isSalesPhase: Boolean
                            $plannedTask_IsDone: Boolean
                            $startDateGte: Date
                            $startDateLte: Date
                        ) {
                            greenhouse(id: $greenhouse_Id) {
                                id
                                greenhouseDepartmentSet(
                                    isPlaceholder: false
                                    orderBy: "name"
                                ) {
                                    edges {
                                        node {
                                            id
                                            name
                                        }
                                    }
                                }
                            }
                            tenantPotSizes(orderBy: "potSizeCm") {
                                edges {
                                    node {
                                        id
                                        potSizeCm
                                    }
                                }
                            }
                            tenantPlannedTaskPhases(
                                first: $first
                                orderBy: $orderBy
                                search: $search
                                plannedTask_PlanFolder_Id: $plannedTaskPlanFolderId
                                plannedTask_PlanFolder_Id_Isnull: $plannedTaskPlanFolderIdIsnull
                                greenhouseDepartmentSection_GreenhouseDepartment_Greenhouse_Id: $greenhouse_Id
                                greenhouseDepartmentSection_GreenhouseDepartment_Id: $greenhouseDepartment_Id
                                plannedTask_PotSize_Id: $potSize_Id
                                searchYear: $searchYear
                                searchWeek: $searchWeek
                                phaseNo: $phaseNo
                                isSalesPhase: $isSalesPhase
                                plannedTask_IsDone: $plannedTask_IsDone
                                startDate_Gte: $startDateGte
                                startDate_Lte: $startDateLte
                            ) {
                                edges {
                                    node {
                                        id
                                        phaseNo
                                        isSalesPhase
                                        spaceM2
                                        startDate
                                        endDate
                                        numDays
                                        m2Days
                                        operatingCostValue
                                        plannedTask {
                                            id
                                            rawId
                                            growthStartDate
                                            growthEndDate
                                            isDone
                                            quantity
                                            youngPlantCostValue
                                            plantFixedCostValue
                                            failureRate
                                            expectedSalesPrice
                                            expectedRevenue
                                            expectedProfit
                                            growthCost
                                            productFixedCostRate
                                            productFixedCostValue
                                            totalM2Days
                                            totalOperatingCostValue
                                            supplier {
                                                id
                                                name
                                            }
                                            plant {
                                                id
                                                name
                                                plantSpecies {
                                                    id
                                                    name
                                                }
                                            }
                                            potSize {
                                                id
                                                potSizeCm
                                            }
                                            color {
                                                id
                                                color
                                            }
                                            environment {
                                                id
                                                environment
                                            }
                                            tag {
                                                id
                                                tag
                                            }
                                        }
                                        greenhouseDepartmentSection {
                                            id
                                            name
                                            greenhouseDepartment {
                                                id
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        first: 1000,
                        orderBy: _orderBy,
                        search: this.search,
                        greenhouse_Id: this.selectedGreenhouse.id,
                        greenhouseDepartment_Id: this
                            .selectedPlanListDepartmentId,
                        potSize_Id: this.selectedPlanListPotSizeId,
                        plannedTaskPlanFolderId: this.selectedPlanFolderID,
                        plannedTaskPlanFolderIdIsnull:
                            this.selectedPlanFolderID == null &&
                            this.selectedPlanFolderName == "Default"
                                ? true
                                : false,
                        searchYear: this.selectedYear,
                        searchWeek: this.selectedWeek,
                        phaseNo:
                            this.selectedPlanListPhaseNo > 0
                                ? this.selectedPlanListPhaseNo
                                : null,
                        isSalesPhase: this.selectedIsSalePhase,
                        plannedTask_IsDone: _isDone,
                        startDateGte:
                            this.dates.length == 2 ? this.dates[0] : null,
                        startDateLte:
                            this.dates.length == 2 ? this.dates[1] : null
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    return response.data.tenantPlannedTaskPhases.edges;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isExportingExcel = false;
                });
            return result;
        },

        clearAndRefresh() {
            this.dates = [];
            this.refreshWholePageData();
        },

        refreshWholePageData() {
            // refresh section charts dialog if open
            if (this.departmentSectionListDialog) {
                this.getSelectedGreenhouseDepartment(
                    this.selectedGreenhouseDepartment.id,
                    this.selectedYear,
                    this.selectedPlanFolderID,
                    this.planFolderNullFilter
                );
            }
            // fetch greenhouse planned space
            this.$refs.greenhousePlannedSpaceRef.getGreenhousePlannedSpace(
                this.selectedGreenhouse.id,
                this.selectedYear,
                this.selectedPlanFolderID,
                this.planFolderNullFilter
            );
            // fetch greenhouse planned finance
            this.$refs.greenhousePlannedFinanceRef.getGreenhousePlannedFinance(
                this.selectedGreenhouse.id,
                this.selectedYear,
                this.selectedPlanFolderID,
                this.planFolderNullFilter
            );

            if (this.toggleViewType == 0) {
                this.getGreenhouseDepartmentSet();
            } else {
                this.getPlannedTaskPhases();
            }
        },

        funcIsoYearWeek(d) {
            const _isoWeekYear = moment(d).isoWeekYear();
            const _isoWeek = moment(d).isoWeek();
            return _isoWeekYear + "-W" + _isoWeek;
        },

        resetSorters() {
            this.sorters = [];
        },

        restoreSorters() {
            this.sorters = JSON.parse(JSON.stringify(this.defaultSorters));
        },

        getPlannedTaskPhases() {
            if (!this.selectedGreenhouse.id || !this.selectedYear) {
                return;
            }

            // reset data table page to first page
            if (this.shouldResetDataTablePage) {
                this.dataTableOptions.page = 1;
            }

            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (!this.shouldResetDataTablePage && page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantPlannedTaskPhases.pageInfo.startCursor;
                _after = null;
            }

            if (!this.shouldResetDataTablePage && page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantPlannedTaskPhases.pageInfo.endCursor;
            }
            if (this.toggleViewType == 1) {
                switch (sortBy[0]) {
                    case "node.plannedTask.rawId":
                        _orderBy = "rawId";
                        break;
                    case "node.startDate":
                        _orderBy = "startDate";
                        break;
                    case "node.endDate":
                        _orderBy = "endDate";
                        break;
                    case "node.greenhouseDepartmentSection.greenhouseDepartment.name":
                        _orderBy = "greenhouseDepartmentName";
                        break;
                    case "node.greenhouseDepartmentSection.name":
                        _orderBy = "greenhouseDepartmentSectionName";
                        break;
                    case "node.plannedTask.plant.plantSpecies.name":
                        _orderBy = "plantSpeciesName";
                        break;
                    case "node.plannedTask.plant.name":
                        _orderBy = "plantName";
                        break;
                    case "node.plannedTask.potSize.potSizeCm":
                        _orderBy = "potSize";
                        break;
                    case "node.plannedTask.color.color":
                        _orderBy = "color";
                        break;
                    case "node.plannedTask.environment.environment":
                        _orderBy = "environment";
                        break;
                    case "node.plannedTask.tag.tag":
                        _orderBy = "tag";
                        break;
                    case "node.plannedTask.supplier.name":
                        _orderBy = "supplierName";
                        break;
                    case "node.plannedTask.expectedRevenue":
                        _orderBy = "expectedRevenue";
                        break;
                    case "node.plannedTask.expectedProfit":
                        _orderBy = "expectedProfit";
                        break;
                    case "node.plannedTask.growthCost":
                        _orderBy = "growthCost";
                        break;
                    case "node.plannedTask.quantity":
                        _orderBy = "quantity";
                        break;
                    case "node.plannedTask.youngPlantCostValue":
                        _orderBy = "youngPlantCostValue";
                        break;
                    case "node.plannedTask.plantFixedCostValue":
                        _orderBy = "plantFixedCostValue";
                        break;
                    case "node.plannedTask.totalOperatingCostValue":
                        _orderBy = "totalOperatingCostValue";
                        break;
                    case "node.spaceM2":
                        _orderBy = "spaceM2";
                        break;
                    case "node.phaseNo":
                        _orderBy = "phaseNo";
                        break;
                    case "node.plannedTask.isDone":
                        _orderBy = "isDone";
                        break;
                    default:
                        _orderBy = "startDate";
                        break;
                }

                if (sortDesc[0] === true) {
                    _orderBy = "-" + _orderBy;
                }
            }

            const _isDone = this.hideDoneTasks ? false : null;

            this.isLoadingPlannedTaskPhases = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query tenantPlannedTaskPhases(
                            $first: Int
                            $last: Int
                            $before: String
                            $after: String
                            $orderBy: String
                            $search: String
                            $greenhouse_Id: ID!
                            $greenhouseDepartment_Id: ID
                            $plannedTaskPlanFolderId: ID
                            $plannedTaskPlanFolderIdIsnull: Boolean
                            $potSize_Id: ID
                            $searchYear: Int
                            $searchWeek: Int
                            $phaseNo: Int
                            $isSalesPhase: Boolean
                            $plannedTask_IsDone: Boolean
                            $startDateGte: Date
                            $startDateLte: Date
                        ) {
                            greenhouse(id: $greenhouse_Id) {
                                id
                                greenhouseDepartmentSet(
                                    isPlaceholder: false
                                    orderBy: "name"
                                ) {
                                    edges {
                                        node {
                                            id
                                            name
                                        }
                                    }
                                }
                            }
                            tenantPotSizes(orderBy: "potSizeCm") {
                                edges {
                                    node {
                                        id
                                        potSizeCm
                                    }
                                }
                            }
                            tenantPlannedTaskPhases(
                                first: $first
                                last: $last
                                before: $before
                                after: $after
                                orderBy: $orderBy
                                search: $search
                                plannedTask_PlanFolder_Id: $plannedTaskPlanFolderId
                                plannedTask_PlanFolder_Id_Isnull: $plannedTaskPlanFolderIdIsnull
                                greenhouseDepartmentSection_GreenhouseDepartment_Greenhouse_Id: $greenhouse_Id
                                greenhouseDepartmentSection_GreenhouseDepartment_Id: $greenhouseDepartment_Id
                                plannedTask_PotSize_Id: $potSize_Id
                                searchYear: $searchYear
                                searchWeek: $searchWeek
                                phaseNo: $phaseNo
                                isSalesPhase: $isSalesPhase
                                plannedTask_IsDone: $plannedTask_IsDone
                                startDate_Gte: $startDateGte
                                startDate_Lte: $startDateLte
                            ) {
                                edgeCount
                                totalCount
                                pageInfo {
                                    startCursor
                                    endCursor
                                    hasPreviousPage
                                    hasNextPage
                                }
                                edges {
                                    node {
                                        id
                                        phaseNo
                                        isSalesPhase
                                        spaceM2
                                        startDate
                                        endDate
                                        numDays
                                        m2Days
                                        operatingCostValue
                                        plannedTask {
                                            id
                                            rawId
                                            growthStartDate
                                            growthEndDate
                                            isDone
                                            quantity
                                            youngPlantCostValue
                                            plantFixedCostValue
                                            failureRate
                                            expectedRevenue
                                            expectedProfit
                                            growthCost
                                            expectedSalesPrice
                                            productFixedCostRate
                                            productFixedCostValue
                                            totalM2Days
                                            totalOperatingCostValue
                                            supplier {
                                                id
                                                name
                                            }
                                            planFolder {
                                                id
                                                name
                                            }
                                            plant {
                                                id
                                                name
                                                plantSpecies {
                                                    id
                                                    name
                                                }
                                            }
                                            potSize {
                                                id
                                                potSizeCm
                                            }
                                            color {
                                                id
                                                color
                                            }
                                            environment {
                                                id
                                                environment
                                            }
                                            tag {
                                                id
                                                tag
                                            }
                                        }
                                        greenhouseDepartmentSection {
                                            id
                                            name
                                            greenhouseDepartment {
                                                id
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        first: _first,
                        last: _last,
                        before: _before,
                        after: _after,
                        orderBy: _orderBy,
                        search: this.search,
                        plannedTaskPlanFolderId: this.selectedPlanFolderID,
                        plannedTaskPlanFolderIdIsnull:
                            this.selectedPlanFolderID == null &&
                            this.selectedPlanFolderName == "Default"
                                ? true
                                : false,
                        greenhouse_Id: this.selectedGreenhouse.id,
                        greenhouseDepartment_Id: this
                            .selectedPlanListDepartmentId,
                        potSize_Id: this.selectedPlanListPotSizeId,
                        searchYear: this.selectedYear,
                        searchWeek: this.selectedWeek,
                        phaseNo:
                            this.selectedPlanListPhaseNo > 0
                                ? this.selectedPlanListPhaseNo
                                : null,
                        isSalesPhase: this.selectedIsSalePhase,
                        plannedTask_IsDone: _isDone,
                        startDateGte:
                            this.dates.length == 2 ? this.dates[0] : null,
                        startDateLte:
                            this.dates.length == 2 ? this.dates[1] : null
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    this.tenantPlannedTaskPhases =
                        response.data.tenantPlannedTaskPhases;

                    //// prepare planFilterDepartmentList
                    this.planFilterDepartmentList =
                        response.data.greenhouse.greenhouseDepartmentSet.edges;

                    this.planFilterPotSizeList =
                        response.data.tenantPotSizes.edges;

                    // update this.page
                    this.page = page;
                    this.shouldResetDataTablePage = false;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoadingPlannedTaskPhases = false;
                });
        },

        getGreenhouseDepartmentSet() {
            if (!this.selectedGreenhouse.id) {
                return;
            }

            this.isLoadingGreenhouseDepartmentSet = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query greenhouse(
                            $id: ID!
                            $taskYear: Int!
                            $planFolder: ID
                            $planFolderIsnull: Boolean
                        ) {
                            greenhouse(id: $id) {
                                id
                                greenhouseDepartmentSet(
                                    isPlaceholder: false
                                    orderBy: "name"
                                ) {
                                    edges {
                                        node {
                                            id
                                            name
                                            totalSpaceM2
                                            greenhouseDepartmentPlannedSpaceSet(
                                                taskYear: $taskYear
                                                planFolder: $planFolder
                                                planFolder_Isnull: $planFolderIsnull
                                            ) {
                                                edges {
                                                    node {
                                                        id
                                                        taskWeek
                                                        growthSpaceM2
                                                        salesSpaceM2
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        id: this.selectedGreenhouse.id,
                        taskYear: this.selectedYear,
                        planFolder: this.selectedPlanFolderID,
                        planFolderIsnull: this.planFolderNullFilter
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    if (response.data.greenhouse) {
                        this.selectedGreenhouseDepartmentSet =
                            response.data.greenhouse.greenhouseDepartmentSet;
                    }
                })
                .catch(error => {
                    // Error
                    console.error(error);
                    // We restore the initial user input
                    // this.newTag = newTag;
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoadingGreenhouseDepartmentSet = false;
                });
        },

        updatePlannedTaskStatus(id, isDone) {
            // this.isUpdatingPlannedTaskStatus = true;
            this.isLoadingPlannedTaskPhases = true;

            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation updatePlannedTaskStatus(
                            $input: UpdatePlannedTaskStatusInput!
                        ) {
                            updatePlannedTaskStatus(input: $input) {
                                plannedTask {
                                    id
                                    isDone
                                    numPhases
                                    quantity
                                    totalGrowthDays
                                    maxSalesDays
                                    supplier {
                                        id
                                        name
                                    }
                                    plant {
                                        id
                                        name
                                        plantSpecies {
                                            id
                                            name
                                        }
                                    }
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                    color {
                                        id
                                        color
                                    }
                                    environment {
                                        id
                                        environment
                                    }
                                    tag {
                                        id
                                        tag
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            id: id,
                            isDone: isDone
                        }
                    }
                })
                .then(() => {})
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    this.getPlannedTaskPhases();
                });
        },

        onGreenhouseChartWeekSelected(serialIndex, selectedWeek) {
            this.shouldResetDataTablePage = true;

            this.selectedIsSalePhase = serialIndex == 0 ? false : true;
            if (this.selectedIsSalePhase) {
                this.selectedPlanListPhaseNo = 0;
            } else {
                this.selectedPlanListPhaseNo = null;
            }

            this.selectedWeek = selectedWeek;

            // let firstDate = moment()
            //     .year(this.selectedYear)
            //     .week(selectedWeek)
            //     .weekday(0)
            //     .format("YYYY-MM-DD");
            // let lastDate = moment(firstDate)
            //     .add(6, "days")
            //     .format("YYYY-MM-DD");
            // this.dates = [firstDate, lastDate];

            this.$nextTick().then(() => {
                this.getPlannedTaskPhases();
            });
        },

        onClearSelectedWeek() {
            this.selectedWeek = null;
            this.selectedIsSalePhase = null;
            this.selectedPlanListPhaseNo = null;

            this.getPlannedTaskPhases();
        },

        onClearSearch() {
            this.search = "";

            this.getPlannedTaskPhases();
        },

        onChangeHideDoneTasks() {
            this.getPlannedTaskPhases();
        },

        onPlannedTaskCreated() {
            this.refreshWholePageData();
        },
        onPlannedTaskDeleted() {
            this.refreshWholePageData();
        },

        viewPlannedTask(plannedTask) {
            this.plannedTaskSpaceChartDialog = true;

            this.$refs.plannedTaskSpaceChartDialogRef.getPlannedTaskSpace(
                plannedTask.id
            );
        },

        editPlannedTask(plannedTask, event) {
            // this.editedPlannedTask = plannedTask;
            if (event.target.id == "copyPlanIcon") {
                this.createOrCopyPlanToFolder = true;
                this.PlannedTaskEditaDialogTitle = "Copy Plan";
                this.$refs.plannedTaskEditDialogRef.initializeEditingPlannedTask(
                    plannedTask.id
                );
            } else {
                this.createOrCopyPlanToFolder = false;
                this.PlannedTaskEditaDialogTitle = "Edit Plan";
                this.$refs.plannedTaskEditDialogRef.initializeEditingPlannedTask(
                    plannedTask.id
                );
            }
            this.plannedTaskEditDialog = true;
            this.refreshWholePageData();
        },

        onDeletingPlannedTask(plannedTask) {
            this.deletingPlannedTask = plannedTask;
            this.deletePlannedTaskDialog = true;
        },

        deletePlannedTaskConfirmed(item) {
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation deletePlannedTask(
                            $input: DeletePlannedTaskInput!
                        ) {
                            deletePlannedTask(input: $input) {
                                plannedTask {
                                    id
                                    note
                                    numPhases
                                    supplier {
                                        id
                                        name
                                    }
                                    plant {
                                        id
                                        name
                                        plantSpecies {
                                            id
                                            name
                                        }
                                    }
                                    color {
                                        id
                                        color
                                    }
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                    environment {
                                        id
                                        environment
                                    }
                                    tag {
                                        id
                                        tag
                                    }
                                    plantGrowthTemplate {
                                        id
                                        name
                                    }
                                    supplier {
                                        id
                                        name
                                    }
                                    totalGrowthDays
                                    maxSalesDays
                                    growthStartDate
                                    growthEndDate
                                    salesStartDate
                                    salesEndDate
                                    supplierOrderNo
                                    quantity
                                    unitPurchasePrice
                                    plantFixedCostRate
                                    plantFixedCostValue
                                    failureRate
                                    expectedSalesPrice
                                    productFixedCostRate
                                    productFixedCostValue
                                    currency
                                    plannedTaskPhaseSet {
                                        edges {
                                            node {
                                                id
                                                phaseNo
                                                startDate
                                                endDate
                                                numDays
                                                numPlantsPerM2
                                                spaceM2
                                                isSalesPhase
                                            }
                                        }
                                    }
                                    updatedAt
                                    updatedBy
                                }
                            }
                        }
                    `,
                    variables: {
                        input: {
                            id: item.id,
                            planFolderNodeId: this.selectedPlanFolderID
                        }
                    }
                })
                .then(() => {
                    this.refreshWholePageData();

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `The plan is deleted!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .catch(error => {
                    console.log(error);
                    //this.error = error.graphQLErrors[0].message;
                })
                .finally(() => {
                    // close delete dialog
                    this.deletePlannedTaskDialog = false;
                });
        },

        goToGreenhouseDetail(greenhouse) {
            this.$router.push({
                name: "greenhouse-detail",
                params: { id: greenhouse.id }
            });
        },

        getSelectedGreenhouseDepartment(
            greenhouseDepartmentNodeId,
            taskYear,
            folderID,
            nullFilter
        ) {
            if (!greenhouseDepartmentNodeId || !taskYear) {
                return;
            }

            this.isLoadingSelectedGreenhouseDepartment = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query greenhouseDepartment(
                            $id: ID!
                            $taskYear: Int!
                            $planFolder: ID
                            $planFolderIsnull: Boolean
                        ) {
                            greenhouseDepartment(id: $id) {
                                id
                                name
                                totalSpaceM2
                                greenhouseDepartmentSectionSet(
                                    isPlaceholder: false
                                    orderBy: "name"
                                ) {
                                    edges {
                                        node {
                                            id
                                            name
                                            spaceM2
                                            greenhouseDepartmentSectionPlannedSpaceSet(
                                                taskYear: $taskYear
                                                planFolder: $planFolder
                                                planFolder_Isnull: $planFolderIsnull
                                            ) {
                                                edges {
                                                    node {
                                                        id
                                                        taskWeek
                                                        growthSpaceM2
                                                        salesSpaceM2
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        id: greenhouseDepartmentNodeId,
                        taskYear: taskYear,
                        planFolder: folderID,
                        planFolderIsnull: nullFilter
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    this.selectedGreenhouseDepartment = {
                        ...response.data.greenhouseDepartment
                    };
                })
                .catch(error => {
                    // Error
                    console.error(error);
                    // We restore the initial user input
                    // this.newTag = newTag;
                })
                .finally(() => {
                    this.isLoadingSelectedGreenhouseDepartment = false;
                });
        },

        openDepartmentSectionListDialog(department) {
            this.selectedGreenhouseDepartment = {
                ...department
            };

            this.departmentSectionListDialog = true;

            this.getSelectedGreenhouseDepartment(
                department.id,
                this.selectedYear,
                this.selectedPlanFolderID,
                this.planFolderNullFilter
            );
        },

        closeDepartmentSectionListDialog() {
            this.departmentSectionListDialog = false;

            this.selectedGreenhouseDepartment = {};
        },

        openCreateGrowthTaskFromPlannedTask(plannedTaskNodeId) {
            this.createGrowthTaskFromPlannedTaskDialog = true;

            this.$refs.createGrowthTaskFromPlannedTaskDialogRef.initializePlannedTask(
                plannedTaskNodeId
            );
        },

        onGrowthTaskCreated() {
            if (this.toggleViewType == 0) {
                this.getGreenhouseDepartmentSet();
            } else {
                this.getPlannedTaskPhases();
            }
        },
        createNewPlanFolder() {
            this.$apollo.mutate({
                mutation: gql`
                    mutation CreatePlanFolder($input: CreatePlanFolderInput!) {
                        createPlanFolder(input: $input) {
                            edges {
                                node {
                                    name
                                    id
                                }
                            }
                        }
                    }
                `,
                variables: {
                    input: {
                        name: this.newFolderName
                    }
                }
            });
        },

        onSavePlanQuantity(plannedTask) {
            this.isLoadingPlannedTaskPhases = true;

            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation updatePlannedTaskQuantity(
                            $input: UpdatePlannedTaskQuantityInput!
                        ) {
                            updatePlannedTaskQuantity(input: $input) {
                                plannedTask {
                                    id
                                    isDone
                                    numPhases
                                    quantity
                                    totalGrowthDays
                                    maxSalesDays
                                    youngPlantCostValue
                                    plantFixedCostValue
                                    totalM2Days
                                    totalOperatingCostValue
                                    plant {
                                        id
                                        name
                                        plantSpecies {
                                            id
                                            name
                                        }
                                    }
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                    color {
                                        id
                                        color
                                    }
                                    environment {
                                        id
                                        environment
                                    }
                                    tag {
                                        id
                                        tag
                                    }
                                    plannedTaskPhaseSet {
                                        edges {
                                            node {
                                                id
                                                spaceM2
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            id: plannedTask.id,
                            quantity: plannedTask.quantity,
                            planFolderNodeId: this.selectedPlanFolderID
                        }
                    }
                })
                .then(() => {
                    this.isLoadingPlannedTaskPhases = false;
                    this.getPlannedTaskPhases();

                    // refetch greenhouse planned space
                    this.$refs.greenhousePlannedSpaceRef.getGreenhousePlannedSpace(
                        this.selectedGreenhouse.id,
                        this.selectedYear,
                        this.selectedPlanFolderID,
                        this.planFolderNullFilter
                    );
                    // fetch greenhouse planned finance
                    this.$refs.greenhousePlannedFinanceRef.getGreenhousePlannedFinance(
                        this.selectedGreenhouse.id,
                        this.selectedYear,
                        this.selectedPlanFolderID,
                        this.planFolderNullFilter
                    );

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `The plan is updated!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .catch(error => {
                    this.isLoadingPlannedTaskPhases = false;

                    // Error
                    console.error(error);

                    // show snackbar
                    const payload = {
                        color: "error",
                        message: `Update plan failed!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .finally(() => {});
        },

        openPlantDialog(plant) {
            this.selectedPlantNodeId = plant.id;
            this.selectedPlantNode = plant;
            this.plantDialog = true;
        },

        closePlantDialog() {
            this.plantDialog = false;
            this.selectedPlantNodeId = null;
            this.selectedPlantNode = null;
        }
    }
};
</script>

